export default "__VITE_ASSET__I5x9dTqc__"